import "./about.css";
import Award from "../../img/award.png";

const About = () => {
  return (
    <div className="a">
      <div className="a-left">
        <div className="a-card bg"></div>
        <div className="a-card">
          <img
            src="https://images.pexels.com/photos/7504803/pexels-photo-7504803.jpeg?cs=srgb&dl=pexels-olha-ruskykh-7504803.jpg&fm=jpg"
            alt=""
            className="a-img"
          />
        </div>
      </div>
      <div className="a-right">
        <h1 className="a-title">About Me</h1>
        <p className="a-sub">Fullstack JavaScript Developer</p>
        <p className="a-desc">
          I am a web developer with three and half ( 3+ ) years of experience in
          the technology field, i started learning computer programming language
          in the late 2018. I took online classes from most biggest learning
          platforms like "FreeCodeCamp, W3schools, Sololearn and Edx". I am a
          fullstack javascript developer specializing on both frontend and
          backend technologies.
        </p>
        <div className="a-award">
          <img src={Award} alt="" className="a-award-img" />
          <div className="a-award-texts">
            <h4 className="a-award-title">Developer at Codemate Tech</h4>
            <p className="a-award-desc">
              I am passionated and enjoying working on my own and clients
              projects and actually :- Codemate Tech Team so amazing
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
